var uiCopyToClipboard = {
	copy: "Copier \"{value}\" dans le presse-papier",
	successMessage: "Copié",
	failureMessage: "Impossible de copier!"
};
var uiCopyToClipboardTranslationsFr = {
	uiCopyToClipboard: uiCopyToClipboard
};

export { uiCopyToClipboardTranslationsFr as default, uiCopyToClipboard };
